import {Component} from '@angular/core';

@Component({
  selector: 'app-invoice-info-help',
  standalone: true,
  imports: [],
  templateUrl: './invoice-info-help.component.html',
  styleUrl: './invoice-info-help.component.scss'
})
export class InvoiceInfoHelpComponent {

}
